import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import CoachAbout from "@/components/site/CoachAbout";
import Methodology from "@/components/site/Methodology";
import Platform from "@/components/site/Platform";
import PaceCalculator from "@/components/site/PaceCalculator";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    // Smooth-scroll to a hash target when arriving from another route
    if (location.hash) {
      const id = location.hash.slice(1);
      // Wait one frame so sections are mounted
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [location]);

  return (
    <main data-testid="landing-page" className="relative bg-brand-bg text-white">
      <Navbar />
      <Hero />
      <Manifesto />
      <Services />
      <CoachAbout />
      <Methodology />
      <Platform />
      <PaceCalculator />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
